import type { IViewModel } from './types';

export async function bindIntegrations(vm: IViewModel): Promise<void> {
  await Promise.all([vm._.comments.bind()]);
}
